
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component
  export default class General extends Vue  {
    dialog = false
    editDateMenu = false
    editedItem: any = {
      id: null,
      name: '',
      material: '',
      cost: '',
      length: '',
      bridgeId: -1,
      date: ''
    }
    defaultItem: any = {
      id: null,
      name: '',
      material: '',
      cost: '',
      length: '',
      bridgeId: -1,
      date: ''
    }

    @Prop() readonly id!: object
    @Prop() readonly tab!: number

    //Methods
    public editItem(item: object): void {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    } 
    public addItem(): void {
      this.editedItem = this.defaultItem
      this.dialog = true
    }
    public deleteItem(item: object): void {
      confirm('Are you sure you want to delete this item?') && this.$store.dispatch('bridge/deleteBridgeSpecialItem', item)
    }
    public save(): void {
      this.editedItem.bridgeId = this.id
      this.$store.dispatch('bridge/updateBridgeSpecialItem', this.editedItem )
      this.dialog = false
    } 

    //Getters
    get getBridgeSpecialItems(): any {
      return this.$store.getters['bridge/getBridgeSpecialItems']
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getLoading(): boolean {
      return this.$store.getters['bridge/getLoading']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }
    get getDeletePermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }

    //Watchers
    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.tab == 8) {
        this.editedItem = this.defaultItem
        this.$store.dispatch('bridge/getBridgeSpecialItems', { id: this.id })
        this.$store.commit('bridge/setReload', false)
      }
    }


  }

